<template>
  <info-section-table :fields="fields" :data="data" class="invoice-includes-list">
    <template v-slot:cell-id="{ row }">
      <el-checkbox :value="row.includeToInvoice" @change="handleCheck(row.id, $event)"/>
    </template>
    <template v-slot:cell-price="{ row }">
      {{row.price | toPriceCurrency(dataSourceCurrency.map[row.currencyID] && dataSourceCurrency.map[row.currencyID].title)}}
    </template>
    <template v-slot:cell-conditionID="{ row }">
      {{dataSourceCondition.map[row.conditionID] && dataSourceCondition.map[row.conditionID].title}}
    </template>
    <template v-slot></template>
    <template v-slot:row-controls="{ row }">
      <slot name="controls" :row="row">
      </slot>
    </template>
  </info-section-table>
</template>

<script>
export default {
  name: 'InvoiceIncludeList',
  components: {
    'info-section-table': () => import(/* webpackChunkName: 'InfoSection' */ '@/components/InfoSection/Table.vue')
  },
  props: {
    data: { type: Array }
  },
  data () {
    return {
      defaultFields: [
        { title: this.L10n('include-invoice'), fieldName: 'id' },
        { title: this.L10n('part-number'), fieldName: 'partNumber' },
        { title: this.L10n('part-sn'), fieldName: 'partSN' },
        { title: this.L10n('qty'), fieldName: 'qty' },
        { title: this.L10n('condition'), fieldName: 'conditionID' },
        { title: this.L10n('price'), fieldName: 'price' }
      ]
    }
  },
  computed: {
    fields () {
      return this.defaultFields
    },
    dataSourceCondition () {
      return this.API('Conditions/GetAllDynamic?select=id,title&orderBy=title asc')
    },
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    }
  },
  methods: {
    handleCheck (id, value) {
      const updatedData = this.data.map((item) => {
        let newValue = { ...item }
        if (item.id === id) {
          newValue = { ...newValue, includeToInvoice: value }
        }
        return newValue
      })
      this.$emit('update:data', updatedData)
    }
  }
}
</script>
<style lang="stylus">
  .invoice-includes-list{
    padding-bottom 2rem
    margin-bottom 2rem!important
    border-bottom 2px solid #d3d3d3
  }
</style>
